import cn from 'classnames';

import TextInput from 'components/form-elements/text-input/TextInput';

import { IGenericTextInputGroup } from 'source/NFR.types';

const GenericTextInputGroup: React.FC<IGenericTextInputGroup> = ({ title, options = [] }) => {
  return (
    <div className={cn('generic-input-and-header')}>
      {title && <h2>{title}</h2>}
      {options?.map(textInput => (
        <TextInput key={textInput.name} name={textInput.name} value={textInput.value} label={textInput.label} />
      ))}
    </div>
  );
};

GenericTextInputGroup.displayName = 'GenericTextInputGroup';

export default GenericTextInputGroup;
